// extracted by mini-css-extract-plugin
export var hidden = "_sy-0";